export default "__VITE_ASSET__07cf5b2c__"